import React from 'react'


export const ProfilePicture = () => {
  return (
    <img alt="me" src="me.png" />
  )
}